import { lazy, Suspense } from "react";
import { Navigate, Route, Routes as Rts } from "react-router-dom";
import SignedInRoute from "./auth/SignedInRoute";
import PrivateRoute from "../components/auth/PrivateRoute";
import SignedOutRoute from "./auth/SignedOutRoute";
import Loading from "./Loading";

const LandingPage = lazy(() => import("../pages/external/landing-page/LandingPage"));
const EventPage = lazy(() => import("../pages/external/event-page/EventPage"));
const SignInPage = lazy(() => import("../pages/auth/SignInPage"));
const ResetPasswordPage = lazy(() => import("../pages/auth/ResetPasswordPage"));
const AcceptInvitePage = lazy(() => import("../pages/auth/AcceptInvitePage"));
const ForbiddenPage = lazy(() => import("../pages/error/403ForbiddenPage"));
const NotFoundPage = lazy(() => import("../pages/error/404NotFoundPage"));
const AuthErrorPage = lazy(() => import("../pages/error/AuthErrorPage"));
const MyEventsPage = lazy(() => import("../pages/internal/my-events-page/MyEventsPage"));
const TeamPage = lazy(() => import("../pages/internal/team-page/TeamPage"));
const AnalyticsPage = lazy(() => import("../pages/internal/analytics-page/AnalyticsPage"));
const MyProfilePage = lazy(() => import("../pages/internal/my-profile-page/MyProfilePage"));
const AccountPage = lazy(() => import("../pages/internal/my-profile-page/AccountPage"));
const NotificationsPage = lazy(() => import("../pages/internal/my-profile-page/NotificationsPage"));
const SecurityPage = lazy(() => import("../pages/internal/my-profile-page/SecurityPage"));
const AdminEventPage = lazy(() => import("../pages/internal/admin-event-page/EventPage"));

export default function Routes() {
  return (
    <Suspense
      fallback={
        <div className="flex h-dvh w-full items-center justify-center">
          <Loading size="lg" />
        </div>
      }
    >
      <Rts>
        {/* External Pages */}
        <Route index element={<LandingPage />} />
      <Route path="event/:id" element={<EventPage />} />
      <Route
        path="sign-in"
        element={
          <SignedOutRoute>
            <SignInPage />
          </SignedOutRoute>
        }
      />
      <Route
        path="reset-password"
        element={
          <SignedOutRoute>
            <ResetPasswordPage />
          </SignedOutRoute>
        }
      />
      <Route path="accept-invite" element={<AcceptInvitePage />} />

      {/* Internal Pages */}
      <Route
        path="events"
        element={
          <SignedInRoute>
            <MyEventsPage />
          </SignedInRoute>
        }
      />
      <Route
        path="admin-event/:id"
        element={
          <SignedInRoute>
            <AdminEventPage />
          </SignedInRoute>
        }
      />
      <Route
        path="user-management"
        element={
          <SignedInRoute>
            <TeamPage />
          </SignedInRoute>
        }
      />
      <Route
        path="analytics"
        element={
          <SignedInRoute>
            <AnalyticsPage />
          </SignedInRoute>
        }
      />
      <Route
        path="profile"
        element={
          <SignedInRoute>
            <MyProfilePage />
          </SignedInRoute>
        }
      >
        <Route index element={<Navigate to="account" replace />} />
        <Route
          index
          path="account"
          element={
            <SignedInRoute>
              <AccountPage />
            </SignedInRoute>
          }
        />
        <Route
          path="notifications"
          element={
            <SignedInRoute>
              <NotificationsPage />
            </SignedInRoute>
          }
        />
        <Route
          path="security"
          element={
            <SignedInRoute>
              <SecurityPage />
            </SignedInRoute>
          }
        />
      </Route>
      {/* <Route
        path="signin"
        element={
          <SignedInRoute>
            <SignInPage />
          </SignedInRoute>
        }
      />
      <Route
        path="your-candidates"
        element={
          <PrivateRoute requiredGroups={["counselor", "admin"]}>
            <YourCandidatesPage />
          </PrivateRoute>
        }
      /> */}

      {/* Misc Routes */}
      <Route path="error" element={<AuthErrorPage />} />
      <Route path="forbidden" element={<ForbiddenPage />} />
      <Route path="*" element={<NotFoundPage />} />
      </Rts>
    </Suspense>
  );
}
